import React from 'react'

import Skeleton from 'react-loading-skeleton';

const PageSearchItemLoading = () => {
  return (
    <div className='search-item-card'>
        <div className='search-item-head'>
            <Skeleton style={{margin : "0px 10px"}} circle width={50} height={50} />
            <Skeleton width={100} />
        </div>
        <div className='loc-con' style={{display : "flex" , marginTop : "10px"}}>
            <Skeleton width={300} />
        </div>
        <Skeleton style={{width : "560px", maxWidth : "100%"}} height={30} />
    </div>
  )
}

export default PageSearchItemLoading
